// extracted by mini-css-extract-plugin
export default {"footer":"DpFooter_footer__Y1eCH","error":"DpFooter_error__6Qd0J","close":"DpFooter_close__uCo93"};